module.exports = __webpack_public_path__ + "img/pixing_zc_zhangyunxin.509d1078.jpg";